import { useVatomWalletSdkStore } from '@vatom/wallet-sdk'

import { AppConfig, useAppConfig } from '../store'

export const useConfig = (): AppConfig => {
  const config = useAppConfig()

  if (!config.data) {
    throw new Error('Config not found')
  }

  const walletSdkStore = useVatomWalletSdkStore()
  if (walletSdkStore.isEmbedded && walletSdkStore.walletConfig) {
    return walletSdkStore.walletConfig
  }

  return config.data
}

export const useConfigState = () => {
  const config = useAppConfig()
  if (!config.data) {
    throw new Error('Config not found')
  }

  const walletSdkStore = useVatomWalletSdkStore()
  if (walletSdkStore.isEmbedded && walletSdkStore.walletConfig) {
    return {
      isLoading: false,
      isError: false,
      data: walletSdkStore.walletConfig
    }
  }

  return {
    isLoading: config.isLoading,
    isError: config.isError,
    data: config.data
  }
}
